exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "instagram-feed #instafeed {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between; }\n  instagram-feed #instafeed a {\n    width: 195px;\n    height: 195px; }\n    instagram-feed #instafeed a img {\n      width: 195px;\n      height: 190px;\n      object-fit: cover; }\n", ""]);

// exports
